import React, { useMemo } from 'react';
import { useGetUsersQuery } from 'features/stream/Stream.queries';
import Organization from 'infrastructure/Organization';
import StreamInputSelect from '../StreamInputSelect/StreamInputSelect';
import StreamUtils from 'features/stream/StreamConstants';
import classes from './UserFilter.module.css';

const UserFilter = ({ onChange = () => null, label, showMine = true, userType = 'All' }) => {
  const user = Organization.getUserInfo();
  const { data = [], isLoading } = useGetUsersQuery({});

  const handleChange = (value) => onChange(value);

  const users = useMemo(() => {
    const options = data
      ?.map(({ user, role }) => {
        const { profile_pic } = user;
        const label = StreamUtils.getUsername(user);

        return {
          value: user?.uuid || '',
          label,
          icon: profile_pic,
          role: role,
        };
      })
      .filter((u) => u?.value !== user?.uuid);

    if (showMine) options?.unshift({ label: 'My posts', value: 'mine', hideIcon: true });
    options?.unshift({
      label: 'All users',
      value: 'all',
      hideIcon: true,
    });

    return options;
  }, [data, user?.uuid]);

  if (!users.length > 0) return null;
  return (
    <div className={classes.container}>
      {label && <span className={classes.label}>{label}</span>}
      <StreamInputSelect
        disabled={isLoading}
        options={userType === 'All' ? users : [{hideIcon: true, label: 'All Users', value: 'all'},...users.filter((user) => user.role === userType)]}
        size="small"
        onChange={({ value }) => handleChange(value)}
        defaultValue={''}
        containerClassName="stream-user-filter"
        placeholder={isLoading ? 'Loading...' : 'Select user'}
      />
    </div>
  );
};

export default UserFilter;
